import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Checkbox } from 'semantic-ui-react';
import ReactTable from 'react-table';

import { DISCONTINUED_INGREDIENTS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { DiscontinuedIngredientsFieldEnum as Fields } from 'Common/FieldEnum';
import { CheckboxField } from 'Common/SemanticWrapper';
import { extractTruthyKeys } from 'Common/FormHelper';
import { Config } from 'Common/Constants';

function DiscontinuedIngredientsTable({
  ingredients,
  input: { onChange, value },
  loading,
}) {
  const columns = [
    {
      id: 'Selected',
      accessor: original => Boolean(value[original.Id]),
      Header: () => {
        const allSelected =
          ingredients.length > 0 &&
          ingredients.length === extractTruthyKeys(value).length;

        return (
          <Checkbox
            label=""
            onChange={() => {
              const value = {};
              ingredients.forEach(ing => {
                value[ing.Id] = !allSelected;
              });
              onChange(value);
            }}
            checked={allSelected}
          />
        );
      },
      Cell: ({ row }) => (
        <Checkbox
          label=""
          onChange={() => {
            const id = row._original.Id;
            onChange({ ...value, [id]: !row.Selected });
          }}
          checked={row.Selected}
        />
      ),
      filterable: false,
      sortable: false,
      width: 40,
    },
    {
      accessor: 'CN_Code',
      Header: 'CN Code',
      filterable: true,
      width: 100,
    },
    {
      accessor: 'Description',
      Header: 'Description',
      filterable: true,
    },
  ];

  const recipeColumns = [
    {
      accessor: 'Id',
      Header: 'Id',
      width: 120,
    },
    {
      accessor: 'Description',
      Header: 'Recipe Name',
    },
  ];

  const recipesSubGrid = row => {
    if (row.original.AssociatedRecipes.length === 0) {
      return undefined;
    }

    return (
      <ReactTable
        data={row.original.AssociatedRecipes}
        columns={recipeColumns}
        minRows={1}
        showPagination={false}
        filterable={false}
        sortable={false}
        noDataText={'No recipes found'}
        resizable={false}
      />
    );
  };

  return (
    <ReactTable
      {...Config}
      minRows={5}
      loading={loading}
      columns={columns}
      data={ingredients}
      SubComponent={recipesSubGrid}
      getTrProps={(state, rowInfo, column, instance) => {
        return rowInfo && rowInfo.original.AssociatedRecipes.length === 0
          ? {
              className: 'expander-hidden',
            }
          : {};
      }}
    />
  );
}

function IngredientsFormContainer({ change, ingredients, loading }) {
  React.useEffect(() => {
    // reset selected ingredient ids, when ingredients change
    change(Fields.IngredientIds, {});
  }, [ingredients]);

  return (
    <React.Fragment>
      <Field
        toggle
        label={'Include Recipe Names'}
        name={Fields.PrintRecipe}
        component={CheckboxField}
      />
      <Field
        name={Fields.IngredientIds}
        component={DiscontinuedIngredientsTable}
        ingredients={ingredients}
        loading={loading}
      />
    </React.Fragment>
  );
}

export const IngredientsForm = reduxForm({
  form: DISCONTINUED_INGREDIENTS_REPORT_FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(IngredientsFormContainer);



// WEBPACK FOOTER //
// ./src/pages/DiscontinuedIngredients/components/IngredientsForm.js